import { createContext } from 'react';

export const invertedContext = createContext(false);
